import { Department, ProjectStatus } from '../api';

export const PROJECT_STATUS_ARCHIVED = ProjectStatus.Archived;

export const isReadyToSignSelfControls = (input: {
  department?: Department;
  selfControlComplete: boolean;
  weatherProtectionSelfControlComplete: boolean;
  riskAssessmentComplete: boolean;
}): boolean => {
  if (input.department === Department.WeatherProtection) {
    return input.selfControlComplete
      && input.weatherProtectionSelfControlComplete
      && input.riskAssessmentComplete;
  }

  return input.selfControlComplete && input.riskAssessmentComplete;
};

export const isArchivedProject = (input: {
  status?: ProjectStatus | number | null;
}): boolean =>
  input.status === PROJECT_STATUS_ARCHIVED;

export const isClosedOrHigher = (input: {
  status?: ProjectStatus | number | null;
}): boolean =>
  typeof input.status === 'number' && input.status >= ProjectStatus.Closed;

export const isServerArchivedListItem = (project: {
  projectStatus?: number | null;
}): boolean =>
  project.projectStatus === PROJECT_STATUS_ARCHIVED;

export const resolveHasMonteringsanalys = (input: {
  hasMonteringsanalys?: boolean | null;
  stored?: boolean | null;
}): boolean => {
  if (typeof input.hasMonteringsanalys === 'boolean') {
    return input.hasMonteringsanalys;
  }
  return true;
};
